import { Subject } from 'rxjs';
export var sportsbookList = [];
export var eventSliderList = [];
export var eventMapping = {};
export var marketMapping = {};
export var marketIdMapping = {};
export var statisticsMap = {};
export var gameDetailData = {};
export var sportsbookFilter = {
    filterCompetition: [],
    filterDays: [],
    filterTime: -1,
    filterMBS: [],
    filterLiveStream: false,
    filterLiveEvent: false,
    filterAlarmSet: false,
    filterRapid: false,
    filterCustomRatio: false,
    filterFavorite: false,
    filterKeyword: '',
    selectedCompetitionGroup: {}
};
export var eventUpdateSubject = new Subject();
export var eventDetailSubject = new Subject();
export var sportsSummerySubject = new Subject();
export var customCompetitionPriorty = [];
export var customCompetitionGroupNames = {};
export var sportsSummery = [];
export var popularCompetition = [];
export var highlightedEvents = [];
export var languageFile = {};
